import ApiService from './api';
import type { ApiResponse } from '~/types/api';
import { useI18n } from 'vue-i18n';

export interface MenuItem {
  id: number;
  name: string;
  url: string;
  page_id: number | null;
  page_url: string | null;
  parent_id: number | null;
  position: number;
  status: boolean;
  lang: string;
  reference_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  parent_name?: string;
  children: MenuItem[];
}

export type MenuResponse = ApiResponse<MenuItem[]>;

/**
 * Menü işlemleri için servis sınıfı
 */
export default class MenuService {
  private static instance: MenuService;
  private apiService: ApiService;

  private constructor() {
    this.apiService = ApiService.getInstance();
  }

  /**
   * Singleton örneği al
   */
  public static getInstance(): MenuService {
    if (!MenuService.instance) {
      MenuService.instance = new MenuService();
    }
    return MenuService.instance;
  }

  /**
   * Aktif dili al
   */
  private getCurrentLang(): string {
    // Browser ortamında mı kontrolü
    if (process.client) {
      try {
        // Vue i18n erişimi sağlanıyor mu kontrolü
        const { locale } = useI18n();
        return locale.value || 'tr';
      } catch (error) {
        // Eğer i18n yüklenmediyse veya hook kullanılamıyorsa
        return 'tr';
      }
    }
    // Server-side rendering durumunda varsayılan dil
    return 'tr';
  }

  /**
   * Tüm menü öğelerini getir
   * @param params İsteğe bağlı parametreler
   */
  public async getMenuItems(params?: {
    lang?: string;
  }): Promise<MenuResponse> {
    try {
      // Dil parametresini ekle
      const finalParams = { 
        ...params, 
        lang: params?.lang || this.getCurrentLang() 
      };
      
      const response = await this.apiService.get<MenuItem[]>('/public/menus', finalParams);
      
      // API response yapısı düzeltme - data.data şeklinde geliyor olabilir
      if (response.data && typeof response.data === 'object' && 'data' in response.data) {
        response.data = (response.data as any).data;
      }
      
      return response;
    } catch (error) {
      console.error('Menü öğeleri alınırken hata oluştu:', error);
      throw error;
    }
  }
} 